import api from "../../core/api";
import { Page } from "../../shared/models/models";
import { Lead, LeadsQuery } from "../models/AdminLeadsModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.customersApiBaseUrl };
};

class AdminLeadsApi {
  getLeads(query: LeadsQuery): Promise<Page<Lead>> {
    return api.get<Page<Lead>>(`/v1/admin/leads`, { ...getRequestConfig(), params: query })
      .then(x => x.data);
  }
}

export default new AdminLeadsApi();